module.exports = __webpack_public_path__ + "media/images/cookie-6c6b34dcf9e4a15ea2faafa3d71d024f.jpg";